import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61e1c620"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header-banner-missing-userdata"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 0,
  class: "header__btns"
}
const _hoisted_5 = ["href", "onClick"]
const _hoisted_6 = { class: "visible-on-hover" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "letter",
  style: { '--i': 0 }
}, "   ", -1))
const _hoisted_8 = ["href", "onClick"]
const _hoisted_9 = { class: "visible-on-hover" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "letter",
  style: { '--i': 0 }
}, "   ", -1))
const _hoisted_11 = {
  key: 0,
  class: "main-menu__header"
}
const _hoisted_12 = {
  key: 0,
  class: "settings-link__circle"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "settings-link__circle"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon profile-user" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#profile-user" })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "word-8-truncate" }
const _hoisted_18 = {
  key: 1,
  class: "main-menu__header"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "settings-link__circle" }, [
  /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#profile-user" })
  ])
], -1))
const _hoisted_20 = {
  key: 2,
  class: "main-menu__body"
}
const _hoisted_21 = { class: "main-menu__item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon main-menu__icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#carconnex" })
], -1))
const _hoisted_23 = { class: "main-menu__item" }
const _hoisted_24 = ["href", "onClick"]
const _hoisted_25 = ["xlink:href"]
const _hoisted_26 = { href: "#" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon main-menu__icon",
  width: "20",
  height: "20"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#logout" })
], -1))
const _hoisted_28 = {
  key: 3,
  class: "main-menu__footer"
}
const _hoisted_29 = ["href", "onClick"]
const _hoisted_30 = ["href", "onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "js-animated-notification" }, [
  /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon bell" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#bell" })
  ])
], -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__divider" }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#heart-fill" })
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cart-link__icon" }, [
  /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#cart" })
  ])
], -1))
const _hoisted_36 = {
  key: 0,
  class: "cart-link__baloon"
}
const _hoisted_37 = { class: "header__dropdown" }
const _hoisted_38 = {
  key: 0,
  class: "word-8-truncate"
}
const _hoisted_39 = {
  key: 0,
  class: "avatar"
}
const _hoisted_40 = ["src"]
const _hoisted_41 = {
  key: 0,
  class: "header__dropdown_list",
  style: { 'min-width': 'max-content' }
}
const _hoisted_42 = ["href", "onClick"]
const _hoisted_43 = {
  class: "header__dropdown_icon",
  width: "20",
  height: "20"
}
const _hoisted_44 = ["xlink:href"]
const _hoisted_45 = { class: "header__dropdown_text" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__dropdown_separator" }, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "header__dropdown_icon",
  width: "20",
  height: "20"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#log-out" })
], -1))
const _hoisted_48 = { class: "header__dropdown_text" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon profile-user" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#profile-user" })
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_51 = [
  _hoisted_50
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_navigation_buttons = _resolveComponent("navigation-buttons")!
  const _component_app_language_switcher = _resolveComponent("app-language-switcher")!
  const _component_notification_component = _resolveComponent("notification-component")!
  const _directive_app_auth_required = _resolveDirective("app-auth-required")!
  const _directive_app_header_btn = _resolveDirective("app-header-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isHidden)
      ? (_openBlock(), _createElementBlock("div", _mergeProps({
          key: 0,
          class: "layout__header"
        }, _ctx.$attrs), [
          _createElementVNode("header", {
            class: _normalizeClass(["header", _ctx.headerClasses]),
            id: "header",
            ref: "header"
          }, [
            (_ctx.isJWTUserDtoPresent && !_ctx.JWTUserDto?.id_customer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_i18n_t, {
                    keypath: "header.missingData",
                    tag: "span"
                  }, {
                    field: _withCtx(() => [
                      _createVNode(_component_router_link, { to: "/auth/my-carconnex/my-company/company-info" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.i18n.t("header.myCompanyInfo")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "header__container",
              onTransitionend: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onHeaderHeightChange && _ctx.onHeaderHeightChange(...args)))
            }, [
              (_ctx.headerMode === 'default')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_router_link, {
                      class: "header__logo-link",
                      to: "/"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          class: "logo",
                          src: `/img/${_ctx.brandLabel}/logos/logo.svg`,
                          alt: `${_ctx.brandLabel} logo`
                        }, null, 8, _hoisted_2),
                        _createElementVNode("img", {
                          class: "logo-color",
                          src: `/img/${_ctx.brandLabel}/logos/logo-color.svg`,
                          alt: `${_ctx.brandLabel} logo`
                        }, null, 8, _hoisted_3)
                      ]),
                      _: 1
                    }),
                    (!_ctx.shouldHideNavigationAndButtons)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          (
                                _ctx.routerModel.regionsByTemplate['button-page'].data[
                                    _ctx.appLanguageSwitcherModel.lang
                                ]
                            )
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: {
                                path: '/auth/vehicles-grouped',
                                query: _ctx.fetchVehiclesQueryForLink,
                            },
                                custom: ""
                              }, {
                                default: _withCtx(({ navigate, href }) => [
                                  _withDirectives((_openBlock(), _createElementBlock("a", {
                                    class: "button button--md button--hidden-prefix",
                                    href: href,
                                    onClick: _withModifiers(($event: any) => (_ctx.showCompanyStatusDialog() || navigate()), ["prevent"])
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.routerModel.regionsByTemplate["button-page"].data[
                                            _ctx.appLanguageSwitcherModel.lang
                                        ].buy), 1),
                                    _createElementVNode("span", _hoisted_6, [
                                      _hoisted_7,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routerModel.regionsByTemplate[
                                            'button-page'
                                        ].data[_ctx.appLanguageSwitcherModel.lang].cars?.split(
                                            '',
                                        ), (char, index) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          class: "letter",
                                          style: _normalizeStyle({ '--i': index + 1 }),
                                          key: 'buy' + index
                                        }, _toDisplayString(char), 5))
                                      }), 128))
                                    ])
                                  ], 8, _hoisted_5)), [
                                    [_directive_app_auth_required, { role: 'supplier' }],
                                    [_directive_app_header_btn]
                                  ])
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : _createCommentVNode("", true),
                          (
                                _ctx.routerModel.regionsByTemplate['button-page'].data[
                                    _ctx.appLanguageSwitcherModel.lang
                                ]
                            )
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                to: `/${_ctx.lang}/work-in-progress`,
                                custom: ""
                              }, {
                                default: _withCtx(({ navigate, href }) => [
                                  _withDirectives((_openBlock(), _createElementBlock("a", {
                                    class: "button button--white button--md button--hidden-prefix",
                                    href: href,
                                    onClick: _withModifiers(($event: any) => (_ctx.showCompanyStatusDialog() || navigate()), ["prevent"])
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.routerModel.regionsByTemplate["button-page"].data[
                                            _ctx.appLanguageSwitcherModel.lang
                                        ].sell), 1),
                                    _createElementVNode("span", _hoisted_9, [
                                      _hoisted_10,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routerModel.regionsByTemplate[
                                            'button-page'
                                        ].data[_ctx.appLanguageSwitcherModel.lang].cars?.split(
                                            '',
                                        ), (char, index) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          class: "letter",
                                          key: 'sell' + index,
                                          style: _normalizeStyle({ '--i': index + 1 })
                                        }, _toDisplayString(char), 5))
                                      }), 128))
                                    ])
                                  ], 8, _hoisted_8)), [
                                    [_directive_app_header_btn],
                                    [_directive_app_auth_required, { role: 'supplier' }]
                                  ])
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isMobile)
                      ? (_openBlock(), _createBlock(_component_navigation_buttons, {
                          key: 1,
                          isVehicleDetails: _ctx.isVehicleDetails,
                          navigateToVehicle: _ctx.navigateToVehicle,
                          isFirstVehicleInList: _ctx.isFirstVehicleInList,
                          isLastVehicleInList: _ctx.isLastVehicleInList
                        }, null, 8, ["isVehicleDetails", "navigateToVehicle", "isFirstVehicleInList", "isLastVehicleInList"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "main-menu__overlay",
                onClick: _cache[0] || (_cache[0] = () => _ctx.headerModel.toggleSidebar(false))
              }),
              _createElementVNode("div", {
                class: _normalizeClass(["main-menu__wrapper", {
                        header__nav: !_ctx.isVehicleDetails,
                        'header__nav-vehicle-details': _ctx.isVehicleDetails,
                    }])
              }, [
                (_ctx.isJWTUserDtoPresent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("a", {
                        class: "settings-link",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.routeToDashboard()))
                      }, [
                        (_ctx.userAvatarPresent)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                              _createElementVNode("img", {
                                src: _ctx.sessionModel.userAvatar.value,
                                style: {"object-fit":"cover","width":"100%","height":"100%"}
                              }, null, 8, _hoisted_13)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_16)),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.JWTUserDto?.family_name), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_router_link, {
                        class: "settings-link",
                        to: "/login"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19,
                          _createElementVNode("span", null, [
                            _createVNode(_component_i18n_t, { keypath: "header.brandName" }, {
                              brandName: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.brandName), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ])),
                (_ctx.headerMode !== 'vehicle-details')
                  ? (_openBlock(), _createElementBlock("nav", _hoisted_20, [
                      _createElementVNode("ul", {
                        class: _normalizeClass(["main-menu", {
                                active: _ctx.$route.path.startsWith('/auth/vehicle-details'),
                            }]),
                        style: _normalizeStyle({ marginBottom: _ctx.isMobile && _ctx.isJWTUserDtoPresent ? '100px' : '0' })
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routerModel.regionsByTemplate['header']
                                    .data[_ctx.appLanguageSwitcherModel.lang]?.links, (item) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: item.id
                          }, [
                            (
                                        _ctx.routerModel.routes[_ctx.appLanguageSwitcherModel.lang][
                                            item.page
                                        ]
                                    )
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: 
                                        _ctx.routerModel.routes[_ctx.appLanguageSwitcherModel.lang][
                                            item.page
                                        ].path
                                    ,
                                  custom: ""
                                }, {
                                  default: _withCtx(({ isExactActive, navigate }) => [
                                    _createElementVNode("li", _hoisted_21, [
                                      _createVNode(_component_router_link, {
                                        to: 
                                                _ctx.routerModel.routes[
                                                    _ctx.appLanguageSwitcherModel.lang
                                                ][item.page].path
                                            ,
                                        class: _normalizeClass({ 'is-current': isExactActive }),
                                        onClick: _withModifiers(
                                                () => _ctx.navigateAndCloseSidebar(navigate)
                                            , ["prevent"])
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_22,
                                          _createElementVNode("span", null, _toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to", "class", "onClick"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ], 6),
                      (_ctx.isMobile && _ctx.isJWTUserDtoPresent)
                        ? (_openBlock(), _createElementBlock("ul", {
                            key: 0,
                            class: _normalizeClass(["main-menu", {
                                active: _ctx.$route.path.startsWith('/auth/vehicle-details'),
                            }])
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.mobileMenu, (item, key) => {
                              return (_openBlock(), _createBlock(_component_router_link, {
                                key: key,
                                to: item.href,
                                custom: ""
                              }, {
                                default: _withCtx(({ isExactActive, navigate }) => [
                                  _createElementVNode("li", _hoisted_23, [
                                    _createElementVNode("a", {
                                      href: item.path,
                                      onClick: _withModifiers(($event: any) => (
                                                _ctx.navigateAndCloseSidebar(navigate)
                                            ), ["prevent"])
                                    }, [
                                      (_openBlock(), _createElementBlock("svg", {
                                        class: _normalizeClass(["sprite-icon main-menu__icon", [
                                                    item.class,
                                                    isExactActive ? 'is-current' : '',
                                                ]]),
                                        width: "20",
                                        height: "20"
                                      }, [
                                        _createElementVNode("use", {
                                          "xlink:href": `/img/sprite.svg#${item.sprite}`
                                        }, null, 8, _hoisted_25)
                                      ], 2)),
                                      _createElementVNode("span", null, [
                                        _createVNode(_component_i18n_t, {
                                          keypath: item.i18n
                                        }, null, 8, ["keypath"])
                                      ])
                                    ], 8, _hoisted_24)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            }), 128)),
                            _createElementVNode("li", {
                              class: "main-menu__item --log-out",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ctx.logout()))
                            }, [
                              _createElementVNode("a", _hoisted_26, [
                                _hoisted_27,
                                _createElementVNode("span", null, [
                                  _createVNode(_component_i18n_t, { keypath: "mobileMenu.logOut" })
                                ])
                              ])
                            ])
                          ], 2))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.shouldHideNavigationAndButtons)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      (
                                _ctx.routerModel.regionsByTemplate['button-page'].data[
                                    _ctx.appLanguageSwitcherModel.lang
                                ]
                            )
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: "/auth/vehicles-grouped",
                            custom: ""
                          }, {
                            default: _withCtx(({ href, navigate }) => [
                              _withDirectives((_openBlock(), _createElementBlock("a", {
                                class: "button button--md",
                                href: href,
                                onClick: _withModifiers(($event: any) => (
                                    _ctx.showCompanyStatusDialog() ||
                                        _ctx.navigateAndCloseSidebar(navigate)
                                ), ["prevent"])
                              }, [
                                _createElementVNode("span", null, [
                                  _createVNode(_component_i18n_t, { keypath: "header.buyCar" })
                                ])
                              ], 8, _hoisted_29)), [
                                [_directive_app_auth_required, { role: 'supplier' }]
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_router_link, {
                        to: "/work-in-progress",
                        custom: ""
                      }, {
                        default: _withCtx(({ href, navigate }) => [
                          _withDirectives((_openBlock(), _createElementBlock("a", {
                            class: "button button--white button--md",
                            href: href,
                            onClick: _withModifiers(($event: any) => (
                                    _ctx.showCompanyStatusDialog(true) ||
                                        _ctx.navigateAndCloseSidebar(navigate)
                                ), ["prevent"])
                          }, [
                            _createElementVNode("span", null, [
                              _createVNode(_component_i18n_t, { keypath: "header.sellCar" })
                            ])
                          ], 8, _hoisted_30)), [
                            [_directive_app_auth_required, { role: 'supplier' }]
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              _createVNode(_component_app_language_switcher),
              (_ctx.isManyNews)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "header__notification-link",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(() => _ctx.toggleNotifications(), ["prevent"]))
                  }, _hoisted_32))
                : _createCommentVNode("", true),
              (_ctx.isJWTUserDtoPresent)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _hoisted_33,
                    (!_ctx.isMobile)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: "header__favorites-link",
                          to: "/auth/my-carconnex/my-favorites"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_34
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isApprovedCompany && _ctx.canUseCart)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: _normalizeClass(["header__cart-link cart-link", { 'is-open': _ctx.showCart }]),
                          style: {"margin-top":"2px"}
                        }, [
                          _createVNode(_component_router_link, { to: "/shopping-cart" }, {
                            default: _withCtx(() => [
                              _hoisted_35,
                              (_ctx.cartModel.items.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.cartModel.items.length), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ], 2))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_router_link, {
                        class: "header__btn header__btn_user",
                        to: "/auth/my-carconnex"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createElementVNode("span", null, [
                              _createVNode(_component_i18n_t, { keypath: "common.hello" }),
                              _createTextVNode(" ,  ")
                            ]),
                            (_ctx.isJWTUserDtoPresent)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.JWTUserDto?.given_name), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.sessionModel.userHasAvatar)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_39, [
                                _createElementVNode("img", {
                                  src: _ctx.sessionModel.userAvatar.value
                                }, null, 8, _hoisted_40)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      (_ctx.isJWTUserDtoPresent)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.headerDropdownMenu, (item, key) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                (
                                        !(item.onlyApproveCompany && !_ctx.isApprovedCompany)
                                    )
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: item.href,
                                      custom: ""
                                    }, {
                                      default: _withCtx(({ isExactActive, navigate }) => [
                                        _createElementVNode("a", {
                                          href: item.path,
                                          onClick: _withModifiers(($event: any) => (navigate()), ["prevent"])
                                        }, [
                                          _createElementVNode("li", {
                                            class: _normalizeClass(["header__dropdown_block", isExactActive ? 'active' : ''])
                                          }, [
                                            (_openBlock(), _createElementBlock("svg", _hoisted_43, [
                                              _createElementVNode("use", {
                                                "xlink:href": `/img/sprite.svg#${item.sprite}`
                                              }, null, 8, _hoisted_44)
                                            ])),
                                            _createElementVNode("span", _hoisted_45, [
                                              _createVNode(_component_i18n_t, {
                                                keypath: item.i18n
                                              }, null, 8, ["keypath"])
                                            ])
                                          ], 2)
                                        ], 8, _hoisted_42)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128)),
                            _hoisted_46,
                            _createElementVNode("div", {
                              class: "header__dropdown_block",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.ctx.logout()))
                            }, [
                              _hoisted_47,
                              _createElementVNode("span", _hoisted_48, [
                                _createVNode(_component_i18n_t, { keypath: "dashboardSidebar.logOut" })
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 64))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 3,
                    class: "header__btn header__btn_user",
                    to: "/login"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createVNode(_component_i18n_t, { keypath: "header.brandName" }, {
                          brandName: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.brandName), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _hoisted_49
                    ]),
                    _: 1
                  })),
              _createElementVNode("div", {
                class: "c-pointer menu-trigger js-menu-trigger",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.headerModel.toggleSidebar()), ["stop"]))
              }, _hoisted_51)
            ], 32),
            (_ctx.isMobile)
              ? (_openBlock(), _createBlock(_component_navigation_buttons, {
                  key: 1,
                  class: _normalizeClass({ 'header-buttons-row': _ctx.isVehicleDetails }),
                  isVehicleDetails: _ctx.isVehicleDetails,
                  navigateToVehicle: _ctx.navigateToVehicle,
                  isFirstVehicleInList: _ctx.isFirstVehicleInList,
                  isLastVehicleInList: _ctx.isLastVehicleInList
                }, null, 8, ["class", "isVehicleDetails", "navigateToVehicle", "isFirstVehicleInList", "isLastVehicleInList"]))
              : _createCommentVNode("", true)
          ], 2)
        ], 16))
      : _createCommentVNode("", true),
    _createVNode(_component_notification_component, {
      active: _ctx.isNotificationsOpen,
      "onUpdate:active": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isNotificationsOpen) = $event))
    }, null, 8, ["active"])
  ], 64))
}